
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../vue-loader/lib/style-rewriter?id=data-v-e36dd9ec!../../vue-loader/lib/selector?type=styles&index=0!./PageSizeSelect.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./PageSizeSelect.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler?id=data-v-e36dd9ec!../../vue-loader/lib/selector?type=template&index=0!./PageSizeSelect.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/PageSizeSelect.vue
// module id = 1212
// module chunks = 2